import { TranslocScope } from '@customer-portal/shared/constants';
import {
  createClearTranslationsCache,
  createScopedTranslationsResolver,
} from '@customer-portal/shared/services/translation';

const loadedTranslations = new Map<string, boolean>();

export const clearFeatureAnnouncementsTranslationsCache =
  createClearTranslationsCache(loadedTranslations);

export const featureAnnouncementsTranslationsResolver =
  createScopedTranslationsResolver(
    TranslocScope.FEATURE_ANNOUNCEMENTS,
    loadedTranslations,
    (lang) => import(`../../i18n/${lang}.json`),
  );
